import countryList from './countryList.ru';

const ru = {
  message: {
    newsPage: {
      title: 'Новости'
    },
    documentsPage: {
      title: 'Документы',
      noData: 'Нет данных',
      tabs: {
        active: 'Активные',
        pending: 'Ожидающие',
        archive: 'Архив документов'
      },
      heading: {
        type: 'Наименование документа',
        category: 'Наименование категории',
        dateStart: 'Дата вступления в силу документа',
        dateEnd: 'Дата окончания действия документа'
      },
      active: {
        loan: 'Договор займа (образец)',
        rules: 'Правила работы Сервиса',
        scoring: 'Положение о скоринге',
        service: 'Договор возмездного оказания услуг',
        offer: 'Оферта ОАО Паритетбанк',
        policy: 'Политика обработки персональных данных'
      },
      documents: {
        offer: 'Оферта ОАО Паритетбанк',
        rules: 'Правила работы Сервиса (ред. до 14.11.2023)',
        newRules: 'Правила работы Сервиса (ред. 15.11.2023)',
        scoring: 'Положение о скоринге',
        serviceContract: 'Договор возмездного оказания услуг (ред. до 14.11.2023)',
        newServiceContract: 'Договор возмездного оказания услуг (ред. 15.11.2023)',
        personalDataProcessing: 'Политика обработки персональных данных',
        personalDataAgreement: 'Согласие на обработку персональных данных',
        contractTemplate: 'Договор займа (образец, ред. до 14.11.2023)',
        newContractTemplate: 'Договор займа (образец, ред. 15.11.2023)'
      }
    },
    messagesPage: {
      placeholder: 'Написать сообщение',
      btn: 'Отправить',
      tostMsg: 'Сообщение успешно отправлено',
      categoryTitle: 'Выберите категорию',
      messageTitle: 'Сообщение',
      contractNumberTitle: 'Номер договора',
      contractNumberPlaceholder: 'Введите номер договора',
      borrowerLastNameTitle: 'Фамилия заемщика',
      borrowerLastNamePlaceholder: 'Введите фамилию заемщика',
      borrowerFirstNameTitle: 'Имя заемщика',
      borrowerFirstNamePlaceholder: 'Введите имя заемщика',
      borrowerMiddleNameTitle: 'Отчество заемщика',
      borrowerMiddleNamePlaceholder: 'Введите отчество заемщика',
      repaymentTypeTitle: 'Тип погашения',
      repaymentTypePlaceholder: 'Выберите тип погашения',
      repaymentAmountTitle: 'Сумма погашения',
      repaymentAmountPlaceholder: 'Введите сумму погашения',
      repaymentDateTitle: 'Дата погашения',
      repaymentDatePlaceholder: 'Выберите дату погашения',
      repaymentMethodTitle: 'Способ погашения',
      repaymentMethodPlaceholder: 'Выберите способ погашения',
      contractActionTitle: 'Действие по договору',
      contractActionPlaceholder: 'Выберите действие по договору',
      contractActionList: {
        close_loan_agreement: 'Закрыть договор займа',
        reflect_in_loan_agreement: 'Отразить в договоре займа'
      },
      repaymentMethodList: {
        opi: 'Через ОПИ',
        voluntary_to_card: 'Добровольно на карту',
        debt_forgiveness: 'Прощение долга',
        voluntary_by_third_party: 'Добровольно третьим лицом'
      },
      repaymentTypeList: {
        full: 'Полностью',
        partial: 'Частично'
      },
      categoryList: {
        loan_conclusion: 'Заключение сделки займа',
        loan_repayment_outside_service: 'Уведомление о погашении займа вне сервиса',
        other: 'Прочее'
      }
    },
    settingsPage: {
      userInfo: {
        fullName: 'ФИО',
        birthDate: 'Дата рождения',
        phoneNumber: 'Номер телефона',
        passportSeriesNumber: 'Серия и номер документа',
        registrationAddress: 'Адрес регистрации'
      },
      changePassword: {
        title: 'Изменение пароля',
        description: 'Обновите свой пароль, чтобы обеспечить безопасность вашей учетной записи',
        btn: 'Изменить'
      },
      changeContactInfo: {
        title: 'Редактирование контактной информации',
        description: 'Укажите свои актуальные контактные данные и адрес проживания',
        btn: 'Редактировать'
      },
      changeWorkInfo: {
        title: 'Редактирование информации о месте работы',
        description: 'Укажите актуальные данные о месте работы',
        btn: 'Редактировать'
      },
      changePersonalDataAgreement: {
        title: 'Согласие на обработку персональных данных',
        description: 'Дать или отозвать согласие на обработку персональных данных',
        btn: 'Перейти'
      },
      actualizeDataViaMsi: {
        title: 'Актуализации данных через МСИ',
        description: 'Актуализировать персональные данные через сервис МСИ',
        btn: 'Актуализировать',
        modal: {
          title: 'Вы подтверждаете актуализацию данных через сервис МСИ?',
          description: 'Актуализация данных через сервис МСИ доступна только 1 раз в месяц, при нажатии кнопки "Актуализировать" вы будете перенаправлены на сторонний сервис для получения актуальных данных',
          cancelBtn: 'Отмена',
          confirmBtn: 'Актуализировать'
        },
        fields: {
          fullName: 'ФИО',
          idDocumentSeriesNumber: 'Серия и номер документа',
          phoneNumber: 'Номер телефона',
          registrationAddress: 'Адрес места регистрации'
        },
        cancelBtn: 'Отменить',
        saveBtn: 'Сохранить',
        saveSuccess: 'Данные сохранены успешно'
      }
    },
    loanPage: {
      back: 'Назад',
      title: 'Транзакции',
      notice: '* - без учёта комиссий',
      repaymentTitle: 'Погашение',
      issuanceTitle: 'Поступление средств',
      noData: 'нет данных',
      agreementCopied: 'Номер договора скопирован в буфер обмена',
      downloadAgreementBtn: 'Скачать договор',
      earlyRepayment: {
        title: 'Досрочное погашение',
        sentAt: 'Уведомление отправлено',
        payFrom: 'Оплата доступна',
        downloadNotification: 'Скачать уведомление',
      },
      paymentStatus: {
        completed: 'Успешно',
        failed: 'Ошибка',
        pending: 'В процессе',
      },
      details: {
        title: 'Информация о займе',
        lenderInfoTitle: 'Информация о займодавце',
        borrowerInfoTitle: 'Информация о заёмщике',
        days: 'д.',
        items: {
          agreement: '№ договора',
          borrower: 'Заёмщик',
          lender: 'Займодавец',
          familyName: 'Фамилия',
          givenName: 'Имя',
          middleName: 'Отчество',
          rating: 'Рейтинг заёмщика',
          email: 'Электронная почта',
          nationalIdNumber: 'Идентификационный номер',
          idDocumentType: 'Вид документа, удостоверяющего личность',
          idDocumentSeriesNumber: 'Серия и номер документа',
          idDocumentIssueDate: 'Дата выдачи',
          idDocumentAuthority: 'Кем выдан',
          registrationAddress: 'Адрес места регистрации',
          residenceAddress: 'Адрес места жительства',
          mobilePhone: 'Номер телефона',
          workPlace: 'Место работы',
          companyName: 'Наименование организации',
          employmentType: 'Вид занятости',
          issued: 'Дата выдачи',
          amount: 'Сумма',
          term: 'Срок',
          percent: '% годовых',
          income: 'Итого к возврату (ОД + %)',
          issuedBy: 'Дата возврата',
          peni: 'Пени',
          totalAmount: 'Итого к погашению',
          repaidDate: 'Дата погашения',
          status: 'Статус займа'
        }
      },
      items: {
        date: 'Дата транзакции',
        amount: 'Сумма транзакции*',
        total: 'В т.ч. ОД',
        percent: 'В т.ч. %',
        peni: 'В т.ч. пени',
        status: 'Статус',
      }
    },
    changeWorkInfoPage: {
      title: 'Сведения о месте работы',
      extraTitle: 'Дополнительные сведения',
      empty: 'Данные о месте работы отсутствуют',
      extraEmpty: 'Дополнительные сведения отсутствуют',
      editBtn: 'Редактировать информацию',
      borrowerNotice: 'Обращаем внимание, что редактировать информацию о месте работы и дополнительную информацию можно только при истекшем сроке согласия на предоставление кредитного отчета из Кредитного регистра и до подписания нового согласия.',
      fields: {
        employmentType: 'Вид занятости',
        scopeOfEmployment: 'Сфера занятости',
        organizationName: 'Наименование организации',
        jobPosition: 'Должность',
        jobPositionName: 'Название должности',
        workExperience: 'Стаж работы в данной организации (мес)',
        organizationUnp: 'УНП'
      },
      extraFields: {
        education: 'Образование',
        driversLicense: 'Водительское удостоверение',
        carOwner: 'Автомобиль в собственности',
        realEstateOwner: 'Недвижимость в собственности',
        familyStatus: 'Семейное положение',
        dependensNumber: 'Количество иждивенцев',
        childExpenses: 'Обязанность возмещать расходы, затраченные государством на содержание детей',
        totalIncome: 'Общий ежемесячный доход в BYN'
      }
    },
    editWorkInfoPage: {
      currentPrefix: 'Сейчас:',
      btnSave: 'Сохранить',
      btnCancel: 'Отмена',
      workTitle: 'Сведения о месте работы',
      extraTitle: 'Дополнительные сведения',
      fields: {
        employmentType: 'Вид занятости',
        scopeOfEmployment: 'Сфера занятости',
        jobPosition: 'Должность',
        jobPositionName: 'Название должности',
        organizationName: 'Наименование организации',
        workExperience: 'Стаж работы в данной организации (мес.)'
      },
      yesNo: {
        list: {
          true: 'Да',
          false: 'Нет'
        }
      }
    },
    changePasswordPage: {
      btnSave: 'Сохранить',
      btnCancel: 'Отмена',
      oldPassword: {
        label: 'Старый пароль'
      },
      newPassword: {
        label: 'Новый пароль'
      },
      confirmPassword: {
        label: 'Подтверждение нового пароля'
      },
      toastMsg: 'Пароль успешно изменен'
    },
    personalDataAgreementPage: {
      signTitle: 'Подпись:',
      checkboxLabel: 'Текст согласия на обработку персональных данных прочитан мной полностью, с условиями ознакомлен(а) и согласен(а)',
      getOtpBtn: 'Получить код',
      signerTitle: 'Подписант:',
      signBtn: 'Подписать согласие',
      createError: 'Не удалось создать согласие',
      otpError: 'Не удалось отправить код',
      signSuccess: 'Согласие успешно подписано',
      signError: 'Не удалось подписать согласие'
    },
    changePersonalDataAgreementPage: {
      title: 'Согласие на обработку персональных данных',
      consentGiven: 'Дано согласие на обработку персональных данных',
      consentNotGiven: 'Согласие на обработку персональных данных не дано',
      revokeSuccess: 'Согласие успешно отозвано',
      revokeError: 'Ошибка при отзыве согласия',
      buttons: {
        revokeConsent: 'Отозвать согласие',
        giveConsent: 'Дать согласие'
      }
    },
    changeContactInfoPage: {
      contactsTitle: 'Контактные данные',
      addressTitle: 'Адрес проживания',
      sameAddress: 'Адрес проживания совпадает с адресом регистрации',
      footerNote: 'При нажатии на кнопку “Сохранить изменение” Вы подтверждаете достоверность и актуальность данных',
      emailSendError: 'Не удалось отправить письмо',
      emailConfirmSuccess: 'Электронная почта успешно подтверждена',
      emailChangeSuccess: 'Электронная почта успешно изменена',
      emailConfirmError: 'Почта не подтверждена',
      addressSaveSuccess: 'Данные сохранены успешно',
      addressSaveError: 'Ошибка сохранения данных',
      buttons: {
        confirm: 'Подтвердить',
        edit: 'Изменить',
        save: 'Сохранить изменения',
        cancel: 'Отмена',
        ok: 'OK'
      },
      emailModal: {
        title: 'Подтверждение электронной почты',
        textStart: 'Мы отправили письмо для подтверждения электронной почты на адрес',
        otpLabel: 'OTP-код'
      },
      fields: {
        phone: 'Телефон',
        email: 'Электронная почта',
        country: 'Страна*',
        postalCode: 'Почтовый код',
        region: 'Область',
        localityType: 'Тип населенного пункта*',
        locality: 'Населенный пункт*',
        streetType: 'Тип локации*',
        street: 'Улица*',
        house: 'Дом*',
        building: 'Корпус',
        apartment: 'Квартира'
      },
      placeholders: {
        country: 'Выберите страну',
        postalCode: 'Введите почтовый код',
        region: 'Введите область',
        localityType: 'Например (город)',
        locality: 'Введите населенный пункт',
        streetType: 'Например (улица)',
        street: 'Введите название локации',
        house: 'Введите номер дома',
        building: 'Введите корпус',
        apartment: 'Введите номер квартиры'
      }
    },
    arbitrationPage: {
      title: 'Третейский суд',
      rules: {
        start: 'Информация о Третейском суде по договорам займа, заключенным после 23.07.2025, а также ',
        bold: 'реквизиты для оплаты',
        end: ' третейского сбора ',
        link: 'здесь'
      },
      desc: 'Свидетельство № 20 выдано Главным Управлением Юстиции Мингорисполкома',
      license: {
        begin: 'Главное управление юстиции Мингорисполкома 02.11.2022 поставило на учет и внесло в ',
        link: 'реестр',
        end: ' третейских судов Республики Беларусь постоянно действующий третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии». Председателем третейского суда избран Берёзкин Вадим Викторович.'
      },
      contact: {
        title: 'Реквизиты / Контакты',
        items: {
          first: {
            title: 'Реквизиты для оплаты третейского сбора:',
            data: [
              'ООО "ИФС" (УНП 193601287)',
              'ОКПО 505592505000',
              'Р/с: BY18 POIS 3012 0139 1603 0193 3002 в ОАО "Паритетбанк"',
              'BIC: POISBY2X',
              'Назначение платежа: Третейский сбор по иску (Ф.И.О. истца) к (Ф.И.О. ответчика)'
            ],
            documentFirst: 'Тарифы суда',
            documentSecond: 'Регламент'
          },
          second: {
            title: 'Место нахождения:',
            data: '220030, г. Минск, ул. Янки Купалы, д. 25, офис 304'
          },
          third: {
            title: 'Телефон',
            data: '+375 (33) 696 09 09'
          },
          fourth: {
            title: 'Email:',
            data: 'court@ifs.by'
          }
        }
      },
      purpose: {
        title: 'Что такое третейский суд:',
        items: [
          'Третейский суд — организация, не входящая в судебную систему Республики Беларусь, создаваемая для разрешения споров в виде постоянно действующего третейского суда или третейского суда, образуемого по соглашению сторон для разрешения конкретного спора.',
          'Третейское соглашение — это двусторонняя сделка, которая порождает у её сторон обязанность в случае спора обратиться в указанный в соглашении третейский суд.',
          'Решение третейского суда вступает в законную силу в день его принятия и подлежит обязательному исполнению в соответствии с законодательством Республики Беларусь. Решение третейского суда, не исполненное добровольно в установленный срок, подлежит принудительному исполнению в порядке, установленном законодательством об исполнительном производстве.',
        ]
      },
      advantages: {
        title: 'Преимущества третейского суда:',
        items: [
          'простая и быстрая процедура',
          'решения третейского суда окончательны и не подлежат обжалованию',
          'разбирательства проходит по месту нахождения третейского суда в г. Минске, а не по месту нахождения ответчика',
          'решения третейского суда исполняются судебными исполнителями принудительно, на основании полученного в суде общей юрисдикции исполнительного листа'
        ]
      },
      advices: {
        title: 'Практические советы:',
        items: {
          first: 'При невозврате денежных средств в установленный срок у Займодавца возникает право на обращение в суд. Следует учитывать, что в соответствии с условиями договора займа и третейской оговоркой предусмотрен обязательный претензионный порядок и определён суд для рассмотрения споров.',
          second: {
            begin: 'Воспользовавшись инструментами Сервиса можно сформировать Претензию, которая будет направлена Заёмщику (должнику). ',
            bold: 'Обращаем внимание на то, что максимальный размер начисляемых пеней по займу составляет 50% от суммы основного долга. Рекомендуем дождаться предусмотренного начисления и затем сформировать Претензию.',
            end: ' Если не дожидаться начисления максимального размера пеней, предусмотренного договором займа, то и подать иск можно на тот размер требований, которые были определены фактической Претензией на дату её составления. В течении 10 дней с момента направления претензии Заёмщиком (должником) должен быть дан ответ Займодавцу на претензию и/или погашены требования.'
          },
          third: 'При отсутствии ответа на Претензию и/или отсутствии погашения требований и истечении 10-дневного срока ответа на Претензию Займодавец имеет право обратиться в суд, воспользовавшись инструментами Сервиса по формированию Искового заявления в третейский суд (по договорам займа, заключенным на Сервисе после 23.07.25).',
          fourth: {
            beginBold: 'В момент подачи Искового заявления должен быть оплачен по реквизитам третейского суда в соответствии с тарифами третейского суда третейский сбор за рассмотрение искового заявления (как правило — 2 БВ) и прикреплён скрин (фото) чека оплаты третейского сбора.',
            firstLink: 'реквизитам третейского суда',
            middleBold: ' в соответствии с ',
            secondLink: 'тарифами третейского суда',
            endBold: ' третейский сбор за рассмотрение искового заявления (как правило — 2 БВ) и прикреплён скрин (фото) чека оплаты третейского сбора.'
          }
        }
      }
    },
    aboutPage: {
      title: 'О нас',
      desc: {
        title: 'Капуста — онлайн-заимствования',
        items: {
          first: 'ООО «ИФС» (Оператор сервиса онлайн-заимствования «Капуста — онлайн-заимствования») оказывает платные услуги по созданию условий для заключения и исполнения посредством сервиса онлайн-заимствования договоров займа денежных средств и договоров, заключенных в обеспечение исполнения обязательств по договору займа денежных средств в соответствии с утвержденными Правилами сервиса онлайн-заимствования, условиями договора возмездного оказания услуг и тарифами сервиса.',
          second: {
            begin: '«Капуста — онлайн-заимствования» — это автоматизированный сервис онлайн-заимствования, который начал свою работу в мае 2023 года и в настоящий момент представлен:',
            important: 'мае 2023 года.',
            end: ' Сегодня сервис доступен для заёмщиков и займодавцев по всей Беларуси.'
          },
          third: {
            begin: 'В настоящий момент ',
            bold: 'Сервисом потребительского онлайн-заимствования ',
            middle: ' Таким образом участниками данного сервиса в соответствии с Правилами работы данного сервиса могут быть только физические лица (подробнее — ',
            link: '(см. – Правила сервиса потребительского онлайн-заимствования)',
            end: ').'
          },
          fourth: 'Предоставление денежных средств в займ посредством сервиса онлайн-заимствования и заключение договоров в обеспечение исполнения обязательств по договору займа денежных средств носят рисковый характер.',
          fifth: 'Оператор сервиса онлайн-заимствования не является стороной по заключаемым посредством этого сервиса онлайн-заимствования договору займа денежных средств и договору, заключенному в обеспечение исполнения обязательств по договору займа денежных средств.',
          sixth: 'Оператор сервиса онлайн-заимствования также не вправе привлекать на свои банковские счета и аккумулировать денежные средства клиентов для их последующего направления заемщикам, иным образом участвовать в движении денежных средств при осуществлении расчетов по договорам займа денежных средств.',
          seventh: 'Юридические лица предоставляют три и более займов в течение календарного месяца одному или нескольким заемщикам в сумме, не превышающей 15 000 базовых величин на одного заемщика на день заключения договора, с соблюдением требований, установленных Указом Президента Республики Беларусь от 23 октября 2019 г. N 394 "О предоставлении и привлечении займов".',
          eighth: 'Индивидуальные предприниматели предоставляют три и более займов в течение календарного месяца одному или нескольким заемщикам в сумме, не превышающей 15 000 базовых величин на одного заемщика на день заключения договора, при условии, что заемщик (заемщики) состоят с ними в трудовых отношениях.'
        }
      },
      values: {
        title: 'Наши ценности',
        data: '«Миссия ООО «ИФС» — повышение доступности финансовых услуг и защиты прав их потребителей, а также формирование условий для дальнейшего развития предпринимательства и деловой инициативы.'
      },
      different: {
        title: 'Что отличает нас от других?',
        items: [
          {
            count: 'first',
            title: 'Экспертиза',
            data: 'Мы успешно представляем услуги с 2023 года, используя лучший опыт и методики финансового рынка, привнося и откликаясь современным условиям.'
          },
          {
            count: 'second',
            title: 'Роботизация',
            data: 'Мы используем в т.ч. автоматизированные технологии при работе с клиентами.'
          },
          {
            count: 'third',
            title: 'P2P платформа',
            data: 'У нас есть собственная автоматизированная платформа «Капуста — онлайн-заимствования» в Республике Беларусь.'
          },
          {
            count: 'fourth',
            title: 'Устойчивый бизнес',
            data: 'Мы всегда стремимся развиваться: улучшать существующие процессы и создавать новые продукты и услуги.'
          },
          {
            count: 'fifth',
            title: 'Экология',
            data: 'Мы стремимся минимизировать воздействие нашей деятельности на окружающую среду. Мы регулируем потребление энергии в офисах, предотвращая чрезмерное использование энергии. Большая часть нашего бизнеса безбумажна, большинство документации хранится в цифровом виде в облачных хранилищах. Мы поддерживаем практику в т.ч. удалённой работы наших сотрудников, чтобы сократить выбросы углекислого газа при поездке на работу и домой.'
          },
          {
            count: 'sixth',
            title: 'Наши люди',
            data: 'Своим успехом мы обязаны нашим работникам. Сотрудники свободно могут пользоваться личным рабочим пространством и предоставленными девайсами, а также зоной отдыха. Наши сотрудники активно проходят различные курсы в целях повышения квалификации. В целях поощрения успешной работы предусмотрены различные бонусы, премии и командировки от имени компании.'
          },
          {
            count: 'seventh',
            title: 'Наши клиенты',
            data: 'Мы стремимся создать удобную финансовую экосистему, чтобы обеспечить реальные финансовые возможности.'
          },
          {
            count: 'eleventh',
            title: 'Управление',
            data: 'Безопасность и прозрачность деятельности является одними из ключевых аспектов нашей работы. Наша компания придерживается установленной политики, касающейся противодействия коррупции, мошенничеству, отмыванию денег, а также по сохранению и конфиденциальности данных. Ежеквартально мы формируем отчётность о деятельности сервиса онлайн-заимствования в Национальный банк Республики Беларусь, а также ежегодно публикуем необходимые финансовые отчёты.'
          }
        ]
      },
      contact: {
        title: 'Раскрытие информации',
        items: {
          first: {
            title: 'Полное наименование организации:',
            data: 'Общество с ограниченной ответственностью «Инновационные Финансовые Стратегии» Сокращенное наименование организации: ООО «ИФС»'
          },
          second: {
            title: 'Дата и номер государственной регистрации:',
            data: 'Общество с ограниченной ответственностью «Инновационные Финансовые Стратегии» зарегистрировано Минским горисполкомом 18 ноября 2021 г. №193601287',
            documentFirst: 'Свидетельство о гос. регистрации',
            middleDataBegin: 'Свидетельство № 1 о включении в ',
            link: 'реестр',
            middleDataEnd: ' Операторов сервисов онлайн-заимствования, выдано Национальным банком Республики Беларусь 14.01.2022. Таким образом Обществу с ограниченной ответственностью «Инновационные Финансовые Стратегии» присвоен статус Оператора сервиса онлайн-заимствования.',
            documentSecond: 'Свидетельство о включении в реестр',
            endData: 'Общество с ограниченной ответственностью «Инновационные Финансовые Стратегии» внесено в реестр резидентов Парка высоких технологий под №1563 с 1 ноября 2025 г.',
            documentThird: 'Свидетельство о регистрации резидента ПВТ'
          },
          third: {
            title: 'Учредителями Общества являются:',
            items: {
              first: '— Овчаров Роман Юрьевич, Республика Беларусь;',
              second: '— Общество с ограниченной ответственностью Инвестиционная Компания «ПИФАГОР» (Российская Федерация);',
              secondWithHalf: '— Общество с ограниченной ответственностью «ОЛИМП Групп» (Российская Федерация);',
              third: 'Бенефициарные владельцы ООО ИК «ПИФАГОР»: Sabr Limited (Seychelles);',
              fourth: 'Бенефициарный владелец Sabr Limited: Габидуллина Ульяна Анатольевна (Российская Федерация);',
              fifth: 'Бенефициарный владелец ООО «ОЛИМП Групп»: Беляков Александр Алексеевич (Российская Федерация);'
            },
            documentFirst: 'Устав',
            documentCharterChanges: 'Изменения в Устав (от 18.09.2026)',
            documentSecond: 'Уведомление о смене местонахождения',
            documentThird: 'Годовая бухгалтерская отчётность 2025',
            documentFourth: 'Годовая бухгалтерская отчётность 2024',
            documentFifth: 'Годовая бухгалтерская отчётность 2023',
            documentSixth: 'Годовая бухгалтерская отчётность 2022'
          },
          archive: {
            first: {
              title: 'Архив (ред. до 10.12.2025)',
              link: 'Уведомление о смене местонахождения'
            },
            second: {
              title: 'Архив (ред. до 11.04.2024)',
              link: 'Уведомление о смене местонахождения'
            },
            third: {
              title: 'Архив (ред. до 15.06.2026)',
              link: 'Уведомление о смене местонахождения'
            },
          },
          fourth: {
            title: 'Адреса и реквизиты:',
            items: {
              first: '220030, г. Минск, ул. Интернациональная, д.38, пом.11-28 (офис 405)',
              second: {
                text: 'e-mail: ',
                link: 'info@kapusta.by'
              },
              third: 'Тел: +375 (25) 908-08-08 (Viber, Telegram, WhatsApp)',
              fourth: '+375 (25) 609-09-09'
            }
          },
          fifth: {
            title: 'Банковские реквизиты:',
            items: {
              first: 'Р/с: BY95 MMBN 3012 0000 0101 0208 4970',
              second: 'в ОАО «Банк Дабрабыт»',
              third: '220002, г.Минск, ул. Коммунистическая, д.49, пом.1',
              fourth: 'BIC MMBNBY22',
              fifth: 'УНП: 193601287',
              sixth: 'ОКПО 505592505000'
            }
          }
        }
      }
    },
    questionsPage: {
      title: 'Частые вопросы',
      items: [
        {
          title: 'Какие есть ограничения при погашении займов на сервисе онлайн-заимствования?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Обращаем Ваше внимание, что ежедневно на сервисе онлайн-заимствования в промежутке 23:45 - 00:10 проводятся технические работы, в указанный временной интервал погашение и оформление займов недоступно. Обработка платежа осуществляется 5-10 минут,  Рекомендуем инициировать оплату не позднее 23:30 во избежание наступления просрочки по договору займа.' }
            ]
          ]
        },
        {
          title: 'Предупреждение о конфиденциальности данных',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: '· Пользователи и Клиенты Сервиса онлайн-заимствования «Капуста – онлайн- заимствования», размещенного в сети Интернет на сайте www.kapusta.by ' },
              { type: 'bold', value: '(далее — Сервис)' },
              { type: 'text', value: ' самостоятельно несут ' },
              { type: 'bold', value: 'ответственность за хранение и использование' },
              { type: 'text', value: ' своих логинов, паролей и подтверждающих кодов из СМС при совершении юридически значимых действий по доступу в межбанковскую систему идентификации (МСИ), а также на Сервисе.' }
            ],
            [
              { type: 'bold', value: '· Запрещено передавать третьим лицам' },
              { type: 'text', value: ' (даже если вам представляются работниками Сервиса/компании) ' },
              { type: 'bold', value: 'логины, пароли и подтверждающие коды из СМС, которые используются при совершении юридически значимых действий по доступу в МСИ, а также на Сервисе (kapusta.by).' }
            ],
            [
              { type: 'bold', value: 'Справочно:' },
              { type: 'text', value: ' с 3 марта 2025 года вступила в силу новая ' },
              { type: 'bold', value: 'статья 12.35 Кодекса об административных правонарушениях Республики Беларусь.' },
              { type: 'text', value: ' Она предусматривает ответственность за незаконное предоставление ' },
              { type: 'bold', value: 'реквизитов банковских платежных карточек либо аутентификационных данных.' },
            ],
            [
              { type: 'text', value: 'Также информируем, что с 3 марта 2025 года изложена в новой редакции ' },
              { type: 'bold', value: 'статья 222 Уголовного кодекса Республики Беларусь.' },
              { type: 'text', value: ' Она предусматривает ответственность за незаконный оборот платежных инструментов, средств платежа и их реквизитов, включая распространение из корыстных побуждений, находящихся в незаконном владении лица реквизитов банковских платежных карточек либо аутентификационных данных.' }
            ],
            [
              { type: 'text', value: 'Пожалуйста, учитывайте требования законодательства при совершении юридически значимых действий. Несоблюдение может повлечь ответственность согласно законодательству Республики Беларусь.' },
            ]
          ]
        },
        {
          title: 'Как получить деньги (займ)?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Для получения займа необходимо ' },
              { type: 'router-link', value: 'Зарегистрироваться', to: 'msi' },
              { type: 'text', value: ' на нашем сайте и иметь платёжную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.' }
            ],
            [
              { type: 'text', value: 'В течении 5 рабочих дней с момента регистрации и предоставления согласия на проверку кредитной истории вам, как Заёмщику будет присвоена рейтинговая оценка на основании ваших данных, после чего вы сможете совершать сделки займа на нашем сервисе.' }
            ],
            [
              { type: 'text', value: 'Все активные предложения по займам размещены на главной странице сайта. Можно воспользоваться предложениями ' },
              { type: 'router-link', value: '«Они готовы выдать деньги прямо сейчас»', to: '/' },
              { type: 'text', value: ' и выбрать те условия займа, которые являются приемлемыми для вас.' }
            ],
            [
              { type: 'text', value: 'Перед перечислением денежных средств вам будет предложено ознакомиться с условиями и подписать договор займа. В момент зачисления вам денежных средств будет отправлено сообщение на указанный вами емайл.' }
            ],
            [
              { type: 'text', value: 'После получения займа внимательно отнеситесь к своевременному погашению займа, т.к. по каждой сделке займа ' },
              { type: 'bold', value: 'подаётся информация в Кредитный регистр Национального банка Республики Беларусь и ваша платёжная дисциплина будет влиять на вашу кредитную историю.' },
              { type: 'text', value: ' Кредитный отчет (кредитную историю) в виде документа на бумажном носителе можно получить в Управлении «Кредитный регистр» Национального банка Республики Беларусь, а также в виде электронного документа посредством ' },
              { type: 'external-link', value: 'веб-портала Кредитного регистра', href: 'https://creditregister.by/' },
              { type: 'text', value: ' в глобальной компьютерной сети Интернет.' }
            ],
            [
              { type: 'text', value: 'Все сведения о заключённых сделках займа будут отражаться в вашем «Профиле» на сайте. Там же следует производить оплаты, связанные с погашением займа.' }
            ]
          ]
        },
        {
          title: 'Как инвестировать (выдать займ)?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Для возможности инвестировать (совершать сделки займа) необходимо ' },
              { type: 'router-link', value: 'Зарегистрироваться', to: 'msi' },
              { type: 'text', value: ' на нашем сайте и иметь платежную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.' }
            ],
            [
              { type: 'text', value: 'Физические лица могут совершать неограниченное число сделок займов в календарном месяце на сервисе онлайн-заимствования.' }
            ],
            [
              { type: 'text', value: 'Чтобы создать свое предложение на займ, следует воспользоваться инструментами сайта по созданию заявки в своем «Профиле». Обратите внимание, что выбрав ' },
              { type: 'bold', value: 'количество займов (публикаций) ваше предложение будет публиковаться исходя из заявленного вами числа раз. Соответственно такое количество займов может быть выдано вами ' },
              { type: 'text', value: '(в т.ч. автоматически) на аналогичных условиях, если на него откликнутся Заёмщики.' }
            ],
            [
              { type: 'text', value: 'Если вы хотите создать предложение с иными условиями, нужно создать новую заявку (предложение) и указать также количество ее публикаций.' }
            ],
            [
              { type: 'text', value: 'Обратите внимание, что срок размещения на сайте предложения (заявки) может быть ограничен ' },
              { type: 'important', value: '30-ю днями' },
              { type: 'text', value: ', после чего оно будет снято с публикации автоматически.' }
            ],
            [
              { type: 'text', value: 'Все активные предложения по займам размещены на главной странице сайта.' }
            ],
            [
              { type: 'text', value: 'Чтобы выдать займ по заявке, опубликованной Заемщиком, следует воспользоваться инструментами сайта, нажав кнопку «Инвестировать», после чего будет направлен запрос Заемщику для подписания договора займа, затем при успешном завершении данного действия произойдет списание денежных средств с Займодавца.' }
            ],
            [
              { type: 'text', value: 'Фактическим перечислением денежных средств по заявке (оферте) вы присоединяетесь к договору займа, подписанному непосредственно Заемщиком. Ознакомиться с образцом договора займа можно в разделе ' },
              { type: 'router-link', value: '«Документы»', to: 'documents' },
              { type: 'text', value: ' на сайте.' }
            ],
            [
              { type: 'text', value: 'Все сведения о заключенных сделках займа будут отражаться в вашем «Профиле» на сайте. Там же будут отражаться все оплаты, связанные с погашением займа.' }
            ],
            [
              { type: 'text', value: 'В случае наступления просрочки на неоплаченную часть будут начисляться пени исходя из двукратной ставки процентов по займу, но не более 50% от суммы основного долга. При длительных просрочках (свыше 30-90 дней) рекомендуем обратиться за взысканием (подробнее – см. ' },
              { type: 'router-link', value: 'Третейский суд', to: 'arbitration' },
              { type: 'text', value: ').' }
            ]
          ]
        },
        {
          title: 'Что обозначает рейтинг (скоринговая оценка) Заемщика?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Порядок, критерии и методика скоринга регулируются ' },
              { type: 'router-link', value: 'Положением о порядке проведения оценки платежеспособности физических лиц – клиентов сервиса потребительского онлайн-заимствования «Капуста – онлайн-заимствования», присвоении скоринговой оценки.', to: 'documents' }
            ],
            [
              { type: 'text', value: 'Скоринговая оценка – результат комплексной финансовой оценки способности Заемщика надлежащим образом исполнить свои обязательства, осуществляемой Оператором на основании анкетных данных Заемщика и анализа ретроспективных данных: информации из Кредитного регистра (КР), информации из ОПИ, истории заимствований на Сервисе. Скоринговая оценка определяется по шкале от 0 до 100 баллов, ' },
              { type: 'bold', value: 'где 100 – наивысшая оценка вероятности Заемщика надлежащим образом исполнить свои обязательства.' }
            ],
            [
              { type: 'text', value: 'Наличие у Заемщика скоринговой оценки ' },
              { type: 'bold', value: 'от 1 до 20 баллов ' },
              { type: 'text', value: '– с высокой вероятностью говорит о наличии текущих просрочек в банках и иных учреждениях свыше 90 дней и (или) открытых исполнительных производствах в ОПИ (о принудительном взыскании долга), указывающей на данные обстоятельства кредитной истории в КР, низкого уровня дохода, рабочей специальности, среднего и (или) средне-специального образования Заемщика, отсутствии в собственности недвижимости и (или) автомобиля и наличии иждивенцев и (или) обязанности возмещать расходы, затраченные государством на содержание детей.' }
            ],
            [
              { type: 'text', value: 'Наличие у Заемщика скоринговой оценки ' },
              { type: 'bold', value: 'от 21 до 40 баллов ' },
              { type: 'text', value: '– с высокой вероятностью говорит о наличии текущих просрочек в банках и иных учреждениях от 30 до 90 дней и (или) открытых исполнительных производствах в ОПИ (о принудительном взыскании долга), указывающей на данные обстоятельства кредитной истории в КР и (или) возрасте Заемщика до 30 лет, низкого уровня дохода, среднего и (или) средне-специального образовании Заемщика, рабочей специальности, отсутствии в собственности недвижимости и (или) наличии иждивенцев.' }
            ],
            [
              { type: 'text', value: 'Наличие у Заемщика скоринговой оценки ' },
              { type: 'bold', value: 'от 41 до 69 баллов ' },
              { type: 'text', value: '– с высокой вероятностью говорит о наличии текущей просрочки до 7 дней и (или) в прошлом факта допущения просрочек в банках и иных учреждениях до 30 дней, указывающей на данные обстоятельства кредитной истории в КР, среднего уровня дохода, вероятном наличии водительских прав и (или) автомобиля в собственности.' }
            ],
            [
              { type: 'text', value: 'Наличие у Заемщика скоринговой оценки ' },
              { type: 'bold', value: 'от 70 до 100 баллов ' },
              { type: 'text', value: '– с высокой вероятностью говорит об удовлетворительной кредитной истории в КР, заявленном уровне дохода свыше 1800 бел.рубл., возрасте Заемщика от 31-50 лет, высшем образовании, наличии водительских прав и (или) автомобиля и (или) недвижимости в собственности и (или) успешно завершенных 2 и более сделках займов на Сервисе (при их наличии без допущения просрочек).' }
            ]
          ]
        },
        {
          title: 'Какие услуги предоставляет оператор сервиса потребительского онлайн-заимствования (далее – Оператор)?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Оператор предоставляет услуги по услуги по созданию условий для заключения и исполнения посредством сервиса онлайн-заимствования договоров займа денежных средств и договоров, заключенных в обеспечение исполнения обязательств по договору займа денежных средств, в т.ч. включающие в себя услуги по выставлению скоринговой оценки Клиента (Заемщика), рассылке уведомлений о заявках, сделках, подтверждениях, оповещениях Клиентам на адрес электронной почты и (или) номер телефона; услуги по предоставлению отчета о полученном доходе Займодавца за период. Услуги оказываются через платформу сервиса, а клиенты заключают договор возмездного оказания услуг с Оператором.' }
            ]
          ]
        },
        {
          title: 'Какое ПО используется на Сервисе?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Сайт – составное произведение, представляющее собой совокупность различной информации и иных результатов интеллектуальной деятельности, а также программ для ЭВМ, содержащихся в информационной системе, обеспечивающей доступность такой информации в сети Интернет по сетевому адресу www.kapusta.by, www.капуста.бел. Администратором и правообладателем Сайта является Оператор. Сервис "Капуста – онлайн-заимствования" может использоваться Клиентами только посредством данного Сайта.' }
            ],
            [
              { type: 'text', value: 'Программное обеспечение – электронный ресурс Оператора, исключительные права на которое принадлежат Оператору, включающий в себя Сервис потребительского онлайн-заимствования «Капуста – онлайн-заимствования» в сети Интернет в виде набора документов в формате HTML (Hyper Text Markup Language), графических файлов, мультимедийных данных, программ и прочего сопутствующего, связанных между собой по смыслу и доступных пользователю по протоколу HTTPS (Hyper Text Transfer Protocol Secure) – протокола передачи гипертекстовых документов с его расширениями для поддержки шифрования и API партнеров, включая банки-партнеры. Программное обеспечение реализуется автоматически, как результат пользования Сайтом и Сервисом.' }
            ]
          ]
        },
        {
          title: 'Какова стоимость услуг Оператора и каков порядок расчетов по договору возмездного оказания услуг?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Оказание услуг Клиенту (Заемщику) – 8% (с учетом комиссии банков и иных партнеров) – удерживается из суммы займа.' }
            ],
            [
              { type: 'text', value: 'Оказание услуг Клиенту (Займодавцу) – 4,5% (с учетом комиссии банков и иных партнеров) – удерживается из суммы платежа, поступающего в пользу Клиента (Займодавца).' }
            ],
            [
              { type: 'text', value: 'За предоставление отчета о полученном доходе Займодавца за период плата составляет 120 белорусских рублей и за бумажную версию отчета дополнительно 1,20 белорусских рублей за каждый лист двусторонней печати. (Электронная версия предоставляется на указанный в профиле Займодавца электронный адрес в течение 3 рабочих дней с момента запроса и оплаты услуги, бумажная версия предоставляется по месту нахождения Оператора в течение 3 рабочих дней с момента запроса и оплаты услуги).' }
            ]
          ]
        },
        {
          title: 'Как осуществляется расчет по договорам займа?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Для осуществления расчетов на Сервисе Клиенту необходимо привязать платежную карту любого белорусского банка, эмитированную в белорусских рублях, позволяющую совершать p2p-переводы без ограничений. Все платежи на Сервисе проходят через платежный терминал банка-партнера. Банком-партнером Оператора является ОАО «Паритетбанк». Платежи по займам проводятся через Личный кабинет Сервиса в соответствии с условиями договора займа. В случае просрочки начисляется пеня.' }
            ]
          ]
        },
        {
          title: 'Какие установлены ограничения?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Неустойка (пени) в рамках Договора займа не может превышать половины суммы займа, предоставленного Заемщику.' }
            ],
            [
              { type: 'text', value: 'Сумма причитающихся заимодавцу процентов по договору займа не может превышать половины суммы займа, предоставленного им по этому договору.' }
            ],
            [
              { type: 'text', value: 'Национальный банк вправе устанавливать предельные размеры процентов, в том числе процентов в годовом исчислении (годовая процентная ставка), по договорам займа, предельные размеры платы по договорам в обеспечение исполнения обязательств.' }
            ],
            [
              { type: 'text', value: 'Оператор вправе в одностороннем порядке устанавливать лимиты, в т.ч. персональные, а также иные лимиты и ограничения по количеству заявок, сумме займа, процентным ставкам и срокам займа для Клиентов. Введение лимитов и ограничений может быть обосновано в т.ч. мотивами необходимости ограничения кредитного риска в отношении Заемщиков для избежания высоковероятных потерь у Займодавцев и (или) при наличии прочих негативных сценариев, по усмотрению Оператора.' }
            ]
          ]
        },
        {
          title: 'Что происходит при исключении Оператора из реестра или прекращении его деятельности?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'В случае исключения Оператора из реестра операторов сервисов онлайн-заимствования Оператор размещает на Сайте информацию об исключении из реестра не позднее 3-х рабочих дней, следующих за днем получения уведомления об исключении из реестра. В случае прекращения деятельности Оператора в результате (при)остановки работы Сервиса, реорганизации или ликвидации Общества, Оператор обязуется в 10-дневный срок уведомить всех Клиентов путем размещения соответствующей информации на Сайте и немедленно приостановить регистрацию новых Клиентов, а также возможность выдачи или получения всеми Клиентами займов. При этом по ранее заключенным сделкам займа у сторон остаются обязательства друг перед другом до полного их исполнения.' }
            ]
          ]
        },
        {
          title: 'Какие риски связаны с использованием сервиса?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Предоставление денежных средств посредством сервиса онлайн-заимствования и заключение договоров в обеспечение исполнения обязательств по договору займа денежных средств носят высокорисковый характер.' }
            ]
          ]
        },
        {
          title: 'Может ли Оператор быть стороной договора займа?',
          noBullets: true,
          lines: [
            [
              { type: 'text', value: 'Оператор сервиса онлайн-заимствования не может быть стороной по заключаемым посредством этого сервиса онлайн-заимствования договору займа денежных средств и договору, заключенному в обеспечение исполнения обязательств по договору займа денежных средств.' }
            ],
            [
              { type: 'text', value: 'Оператор сервиса онлайн-заимствования не вправе привлекать на свои банковские счета и аккумулировать денежные средства клиентов для их последующего направления заемщикам, иным образом участвовать в движении денежных средств при осуществлении расчетов по договорам займа денежных средств.' }
            ]
          ]
        }
      ]
    },
    investingPage: {
      heading: {
        title: 'Капуста — лучшее решение!',
        firstDesc: 'Используя наш сервис вы получаете альтернативную возможность инвестирования. Теперь заключение сделок займов возможно онлайн, 24/7, на условиях, которые вы выбираете сами'
      },
      advantages: {
        title: 'Почему все выбирают Капусту:',
        items: {
          first: 'Выдача и погашение займа круглосуточно',
          second: 'Вы сами выбираете условия, сумму и срок займа',
          third: 'За просроченный платёж в вашу пользу начисляются пени',
          fourth: 'SSL сертификат, защита личной информации',
          fifth: 'Справочно-информационная поддержка',
          sixth: 'Взыскание в третейском суде',
          seventh: 'Аттестованная система защиты информации по классу 3-ин, 3-юл '
        }
      },
      hiw: {
        title: 'Три простых шага для выдачи займа:',
        first: {
          title: 'Регистрация',
          desc: 'через МСИ займёт не более 5 минут. Вы становитесь полноценным участником Сервиса и владельцем личного "карманного" Банка'
        },
        second: {
          title: 'Выдача займа',
          desc: 'для выдачи займа создайте свои уникальные предложения по займам, воспользовавшись инструментами Сервиса, или остановите свой выбор на предложениях Заемщиков'
        },
        third: {
          title: 'Подпись договора',
          desc: 'договор займа является реальным договором. Перечислением денежных средств вы присоединяетесь к условиям договора'
        }
      },
      memo: {
        title: 'Памятка для Займодавцев',
        items: {
          first: {
            begin: 'Для возможности инвестировать (совершать сделки займа) необходимо ',
            link: 'Зарегистрироваться',
            end: ' на нашем сайте и иметь платежную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.'
          },
          second: 'Физические лица могут совершать неограниченное число сделок займов в календарном месяце с использованием Сервиса потребительского-онлайн-заимствования.',
          third: {
            begin: 'Чтобы создать свое предложение на займ, следует воспользоваться инструментами по созданию заявки в личном профиле на нашем сайте в Разделе «Сервис потребительского онлайн-заимствования». Обратите внимание, что выбрав ',
            bold: 'количество займов (публикаций) ваше предложение будет публиковаться исходя из заявленного вами числа раз. Соответственно такое количество займов может быть выдано вами',
            end: ' (в т.ч. автоматически) на аналогичных условиях, если на него откликнутся Заёмщики. Если вы хотите создать предложение с иными условиями, нужно создать новую заявку (предложение) и указать также количество ее публикаций.'
          },
          fourth: 'Если вы хотите создать предложение с иными условиями, нужно создать новую заявку (предложение) и указать также количество ее публикаций.',
          fifth: {
            begin: 'Обратите внимание, что срок размещения на сайте предложения (заявки) может быть ограничен 30-ю днями , после чего оно будет снято с публикации автоматически.',
            important: '30-ю днями',
            end: ', после чего оно будет снято с публикации автоматически.'
          },
          sixth: {
            begin: 'Все активные предложения по займам размещены на нашем сайте в Разделе «Сервис потребительского онлайн-заимствования».',
            beginImportant: ' Также можно воспользоваться заявками Заемщиков ',
            link: '«Они готовы взять деньги прямо сейчас»',
            endImportant: ' и выбрать те условия займа, которые являются приемлемыми для вас.'
          },
          seventh: {
            begin: 'Чтобы выдать займ по заявке, опубликованной Заемщиком, следует воспользоваться инструментами нашего сайта в Разделе «Сервис потребительского онлайн-заимствования», нажав кнопку «Инвестировать», после чего будет направлен запрос Заемщику для подписания договора займа, затем при успешном завершении данного действия произойдет списание денежных средств с Займодавца.',
            link: '«Документы»',
            end: ' на сайте.'
          },
          eighth: {
            begin: 'Фактическим перечислением денежных средств по заявке (оферте) вы присоединяетесь к договору займа, подписанному непосредственно Заемщиком. Ознакомиться с образцом договора займа можно на странице нашего сайта в Разделе «Сервис потребительского онлайн-заимствования» в нижней части страницы, выбрав из выпадающего списка «Сервис потребительского онлайн-заимствования», далее перейти по вкладке - ',
            link: '«Документы»'
          },
          ninth: {
            begin: 'В случае наступления просрочки на неоплаченную часть будут начисляться пени исходя из двукратной ставки процентов по займу, но не более 50% от суммы основного долга. При длительных просрочках (свыше 30-90 дней) рекомендуем обратиться за взысканием (подробнее – см. ',
            link: 'Третейский суд',
            end: ').'
          },
          tenth: 'Все сведения о заключенных сделках займа будут отражаться в личном профиле на странице нашего сайта в Разделе «Сервис потребительского онлайн-заимствования». Там же будут отражаться все оплаты, связанные с погашением займа.'
        },
        note: {
          begin: 'Справочно: Кредитный отчет (кредитную историю) в виде документа на бумажном носителе можно получить в Управлении «Кредитный регистр» Национального банка Республики Беларусь, а также в виде электронного документа посредством ',
          link: 'веб-портала Кредитного регистра',
          end: ' в глобальной компьютерной сети Интернет.'
        }
      },
      signUp: {
        title: 'Зарегистрируйтесь прямо сейчас!',
        btn: 'Зарегистрироваться'
      }
    },
    getLoanPage: {
      heading: {
        title: 'Капуста — лучшее решение!',
        firstDesc: 'Самый быстрый и удобный выход из ситуации, когда срочно нужны деньги — оформить займ в Капусте.',
        secondDesc: 'Получение Займа доступно с любой кредитной историей. В Капусте легко могут получить деньги даже те, кому отказали в банке, а также студенты, пенсионеры и временно безработные. Вам не потребуются справки, страховка и залог. Займ предоставляется на любую карту и без визитов в отделение банка. От вас потребуется только наличие компьютера или мобильного телефона.'
      },
      advantages: {
        title: 'Почему все выбирают Капусту:',
        items: {
          first: 'БЕЗ: справок, залогов, страховок и поручителей',
          second: 'Круглосуточно: потребуется только мобильный телефон',
          third: 'Вы сами выбираете условия, сумму и срок займа',
          fourth: 'Вы платите проценты только за дни пользования займом',
          fifth: 'SSL сертификат, защита личной информации',
          sixth: 'Возможность улучшить свой  рейтинг в Капусте',
          seventh: 'Аттестованная система защиты информации по классу 3-ин, 3-юл '
        }
      },
      hiw: {
        title: 'Три простых шага для получения денег:',
        first: {
          title: 'Регистрация',
          desc: 'через МСИ (с использованием биометрии) займёт не более 5 минут. Вы становитесь полноценным участником Сервиса и владельцем личного «карманного» Банка'
        },
        second: {
          title: 'Получение займа',
          desc: 'все сделки займов заключаются напрямую между физическими лицами. Для получения денег создайте свое уникальное предложение на займ или воспользуйтесь предложениями от Займодавцев и сделайте свой выбор'
        },
        third: {
          title: 'Подпись договора',
          desc: 'осуществляется с помощью аналога собственноручной подписи (просто введите код из SMS- или PUSH-уведомления)'
        }
      },
      memo: {
        title: 'Памятка для Заёмщиков',
        items: {
          first: {
            begin: 'Для получения займа необходимо ',
            link: 'Зарегистрироваться',
            end: ' , выбрав на нашем сайте раздел «Сервис потребительского онлайн-заимствования» и нажав кнопку «Зарегистрироваться», и иметь платёжную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.'
          },
          second: 'В течении 5 рабочих дней с момента регистрации и предоставления согласия на проверку кредитной истории вам, как Заёмщику будет присвоена рейтинговая оценка на основании ваших данных, после чего вы сможете совершать сделки займа на нашем сайте в Разделе «Сервис потребительского онлайн-заимствования».',
          third: {
            begin: 'Все активные предложения по займам размещены на нашем сайте в Разделе «Сервис потребительского онлайн-заимствования». Можно создать свое уникальное предложение, воспользовавшись инструментами сайта по созданию заявки личном профиле, которое отобразится на нашем сайте в Разделе «Сервис потребительского онлайн-заимствования» в блоке ',
            link: '«Они готовы взять деньги прямо сейчас»',
            middle: ' или воспользоваться предложениями Займодавцев ',
            secondLink: '«Они готовы выдать деньги прямо сейчас»',
            end: ' и выбрать те условия займа, которые являются приемлемыми для вас.'
          },
          fourth: 'Перед перечислением денежных средств вам будет предложено ознакомиться с условиями и подписать договор займа. В момент зачисления вам денежных средств будет отправлено сообщение на указанную вами электронную почту.',
          fifth: {
            begin: 'Обращаем внимание, что информация о каждом заключенном договоре займа (в т.ч. соблюдение платежной дисциплины) на Сервисе потребительского онлайн-заимствования подлежит передаче в Кредитный регистр Национального банка Республики Беларусь.',
            end: 'подаётся информация в Кредитный регистр Национального банка Республики Беларусь и ваша платёжная дисциплина будет влиять на вашу кредитную историю.'
          },
          sixth: 'Все сведения о заключённых сделках займа будут отражаться в личном профиле на нашем сайте в Разделе «Сервис потребительского онлайн-заимствования». Там же следует производить оплаты, связанные с погашением займа.'
        },
        note: {
          begin: 'Справочно: Кредитный отчет (кредитную историю) в виде документа на бумажном носителе можно получить в Управлении «Кредитный регистр» Национального банка Республики Беларусь, а также в виде электронного документа посредством ',
          link: 'веб-портала Кредитного регистра',
          end: ' в глобальной компьютерной сети Интернет.'
        }
      },
      signUp: {
        title: 'Зарегистрируйтесь прямо сейчас!',
        btn: 'Зарегистрироваться'
      }
    },
    legislation: {
      title: 'Законодательство',
      firstRow: 'Данный раздел не имеет статуса юридической базы. Публикация нормативных правовых актов, ссылок на них носит справочный, информационный характер.',
      secondRow: {
        firstText: 'Для ознакомления с нормативными правовыми актами можно перейти по ссылке:',
        link: 'Законодательство о сервисах онлайн-заимствования',
        secondText: 'Перейдя по ссылке вы покидаете наш сайт'
      }
    },
    contacts: {
      title: 'Контакты',
      address: {
        title: 'Адрес местонахождения:',
        data: '220030, г. Минск, ул. Интернациональная, д.38, пом.11-28 (офис 405)'
      },
      postalAddress: {
        title: 'Почтовый адрес :',
        data: '220030, г. Минск, Интернациональная, д.38, пом.11-28'
      },
      time: {
        title: 'Время работы офиса:',
        week: 'Понедельник - Пятница',
        data: 'с 09:00 до 18:00'
      },
      phones: {
        title: 'Телефоны:',
        first: '+375 (25) 908-08-08 (Viber, Telegram, WhatsApp)',
        second: '+375 (25) 609-09-09'
      },
      support: {
        title: 'Служба поддержки:',
        data: 'support@kapusta.by'
      }
    },
    contract: {
      otp: {
        placeholder: 'Введите код из SMS'
      },
      successModal: {
        title: 'Поздравляем!',
        desc: {
          text: 'Займ подписан. После подтверждения и перечисления денежных средств сделка будет отражена в ',
          link: 'Профиле'
        },
        btn: 'OK'
      },
      errorModal: {
        title: 'Внимание!',
        desc: 'Не удалось зачислить денежные  средства. Ранее подписанный вами договор займа аннулируется.',
        btn: 'OK'
      },
      btn: 'Подписать договор'
    },
    scoringAgreement: {
      signTitle: {
        borrower: 'ПОДПИСЬ ЗАЕМЩИКА',
        lender: 'ПОДПИСЬ ЗАЙМОДАВЦА'
      }
    },
    bid: {
      title: 'Создание заявки',
      currencyList: {
        BYN: 'BYN',
        USD: 'USD'
      },
      currency: {
        title: 'Выбор валюты'
      },
      totalAmount: {
        title: 'Общая сумма',
        placeholder: '10 000 000'
      },
      minAmount: {
        title: 'Мин. сумма займа',
        placeholder: '100'
      },
      aliquote: {
        title: 'Кратность сумме'
      },
      percent: {
        title: '% годовых',
        placeholder: '12,5%'
      },
      terms: {
        title: 'Срок займа',
        fromPlaceholder: 'c: 22.03.2023',
        toPlaceholder: 'по: 22.03.2023',
        from: 'с',
        to: 'по'
      },
      relevance: {
        title: 'Актуальность заявки',
        toPlaceholder: 'по: 22.03.2023',
        to: 'по'
      },
      paymentProcedure: {
        title: 'Порядок выплат %',
        list: {
          monthly: 'Ежемесячно',
          quarterly: 'Ежеквартально'
        }
      },
      provision: {
        title: 'Обеспечение',
        yes: 'Да',
        no: 'Нет',
        placeholder: 'Гарантия банка',
        list: {
          bank_guarantee: 'Гарантия банка'
        }
      }
    },
    profile: {
      verifyCards: {
        card: {
          title: 'Добавление банковской карты',
          desc: 'Для пополнения вашего счета добавьте банковскую карту, на которую вы хотите получать денежные средства',
          btn: 'Добавить карту'
        },
        agreement: {
          title: 'Предоставление согласия',
          descBorrower: 'Для выставления рейтинга (скоринговой оценки) необходимо дать согласие на предоставление кредитного отчета из Кредитного регистра',
          descLender: 'Необходимо дать согласие на предоставление кредитного отчета из Кредитного регистра',
          btn: 'Предоставить согласие',
          modal: {
            title: 'Предоставить согласие',
            description: 'Перед тем как дать согласие на предоставление кредитного отчёта из Кредитного регистра, Вы можете изменить анкетные данные в настройках личного кабинета. Обратите внимание, что после предоставления согласия внесение изменений будет недоступно до следующего запроса на актуализацию рейтинга (через 3 месяца).',
            editBtn: 'Редактировать информацию',
            giveConsentBtn: 'Предоставить согласие'
          }
        },
        email: {
          title: 'Подтвердить электронную почту',
          desc: 'Для активации профиля и получения актуальной информации от сервиса пройдите подтверждение e-mail',
          btn: 'Подтвердить почту'
        },
        annualActualInfo: {
          title: 'Актуализируйте данные через сервис МСИ',
          desc: 'Для продолжения пользования сервисом вам необходимо актуализировать данные через МСИ',
          btn: 'Актуализировать',
          modalDescription: 'При нажатии кнопки "Актуализировать" вы будете перенаправлены на сторонний сервис для получения актуальных данных'
        },
        verification: {
          title: 'Пройти верификацию',
          desc: 'Для активации вашего профиля необходимо пройти верификацию в МСИ с использованием биометрических данных',
          btn: 'Пройти верификацию'
        }
      },
      rate: 'Рейтинг:',
      settings: 'Настройки профиля',
      activationModal: {
        title: 'Заявка принята',
        text: 'Ваш аккаунт будет активирован в течение 5 рабочих дней*.\nУведомление направим на email.',
        note: '*срок может быть увеличен, если нам потребуются уточняющие данные\nСпасибо за ожидание.',
        btn: 'Продолжить'
      },
      status: {
        new: 'Новый',
        active: 'Активный',
        inactive: 'Не активный',
        waiting: 'В ожидании',
        on_approval: 'В ожидании',
        confirmed: 'В ожидании',
        blocked: 'Заблокирован'
      },
      role: {
        title: 'Статус: ',
        lender: 'Займодавец',
        borrower: 'Заёмщик'
      },
      borrower: {
        activeOffers: {
          title: 'Мои займы',
          noLoans: 'У вас нет активных займов',
          emptyArchiveLoans: 'Список займов пуст',
          noData: 'нет данных',
          items: {
            name: 'Займодавец',
            issued: 'Дата выдачи',
            amount: 'Сумма',
            term: 'Срок',
            percent: '% годовых',
            income: 'Итого к возврату (ОД + %)',
            issuedBy: 'Дата возврата',
            repaidDate: 'Дата погашения',
            peni: 'Пени',
            totalAmount: 'Итого к погашению',
            status: 'Статус займа'
          },
          status: {
            payment: 'Задолженность',
            closed: 'Погашено',
            expired: 'Просрочено',
            paid: 'Активная',
            on_due: 'Задолженность',
            current_debt: 'Задолженность',
            repaid: 'Погашено',
            overdue: 'Просрочено',
            payment_pending: 'Ожидает перевод',
            signing: 'В подписании',
            canceled: 'Отменен',
            payment_failed: 'Ошибка платежа'
          },
          btn: 'Оплатить',
          signBtn: 'Подписать',
          transactions: 'Транзакции',
          payModal: {
            title: 'Оплата займа',
            returnAmount: 'Итого к возврату (ОД + %)',
            penalty: 'Пени',
            total: 'Итого к оплате',
            currency: 'BYN',
            placeholder: 'Введите сумму погашения',
            payBtn: 'Оплатить'
          }
        },
        earlyRepayment: {
          notifyBtn: 'Уведомить о досрочном погашении',
          payBtn: 'Оплатить досрочно',
          awaitingShort: 'Уведомление отправлено',
          awaitingTooltip: 'Уведомление о досрочном погашении отправлено {sentAt}. Оплата будет доступна {payFrom}',
          notifyModal: {
            title: 'Уведомление о досрочном погашении',
            desc: 'Внимательно ознакомьтесь с уведомлением перед подписанием',
            signTitle: 'Подпись:',
            agreement: 'Текст уведомления прочитан мной полностью, с условиями ознакомлен(а) и согласен(а)',
            borrowerTitle: 'Заёмщик:',
            availableFrom: 'Досрочное погашение будет доступно с',
            sendOtp: 'Получить код',
            resendOtp: 'Отправить код повторно',
            resendIn: 'Повторно через {seconds} сек.',
            otpTimer: 'Код действителен: {seconds} сек.',
            confirmBtn: 'Подтвердить уведомление',
            cancelBtn: 'Отмена',
            success: 'Уведомление о досрочном погашении отправлено',
          },
          payModal: {
            title: 'Досрочное погашение',
            principal: 'Сумма займа (ОД)',
            interest: 'Проценты за {days} дн.',
            total: 'Итого к оплате',
            payBtn: 'Оплатить досрочно',
            success: 'Займ успешно погашен досрочно',
          },
          errors: {
            default: 'Не удалось выполнить операцию',
            alreadyNotified: 'Уведомление уже было отправлено',
            notifyUnavailable: 'Сейчас нельзя отправить уведомление',
            notificationRequired: 'Сначала отправьте уведомление о досрочном погашении',
            payUnavailable: 'Сейчас нельзя оплатить досрочно',
            amountMismatch: 'Сумма устарела, выполняется пересчёт',
            amountMismatchDetail: 'Актуальная сумма: {expected} BYN',
            paymentWaiting: 'Дождитесь завершения предыдущего платежа',
            cardSrcNotFound: 'Добавьте карту для списания средств',
            cardDstNotFound: 'У займодавца нет карты для зачисления',
            addCard: 'Добавьте карту для оплаты',
            paymentFailed: 'Ошибка при проведении платежа',
            notifyReason: {
              status: 'Досрочное погашение доступно только при статусе «Задолженность»',
              term: 'Срок займа не подходит для досрочного погашения',
              window: 'Окно отправки уведомления сейчас недоступно',
            },
            payReason: {
              status: 'Досрочное погашение доступно только при статусе «Задолженность»',
              no_notification: 'Сначала отправьте уведомление',
              too_early: 'Дата досрочной оплаты ещё не наступила',
              due_reached: 'Наступил срок обычного погашения',
            },
          },
        },
        noCardLink: 'Добавьте',
        noCardText: ' карту, на которую вы хотите получить деньги',
        noRate: '(менеджер проверяет вашу анкету)',
        noScoringAgreement: {
          start: 'Для выставления рейтинга (скоринговой оценки) необходимо ',
          link: 'дать согласие',
          end: ' на предоставление кредитного отчёта из Кредитного регистра'
        },
        notice: 'Для полного доступа к фунциям "Капуста - онлайн-заимствования" Вам необходимо завершить несколько простых шагов'
      },
      lender: {
        offersTemporarilyBlocked: {
          text: 'Публикация заявок приостановлена по причине отсутствия средств на основной банковской карте. Подтвердите наличие средств.',
          btn: 'Подтверждаю',
          success: 'Наличие средств успешно подтверждено',
          error: 'Не удалось подтвердить наличие средств'
        },
        loans: {
          filter: {
            apply: 'Применить',
            reset: 'Сбросить',
            status: 'Статус',
            borrower: 'Заёмщик',
            issued: 'Дата выдачи',
            repaid: 'Дата возврата',
            repaidDate: 'Дата погашения'
          },
          filterStatus: {
            list: {
              overdue: 'Просрочено',
              current_debt: 'Задолженность',
              signing: 'В подписании',
              payment_failed: 'Ошибка платежа'
            }
          },
          archiveFilterStatus: {
            list: {
              canceled: 'Отменен',
              repaid: 'Погашено',
              payment_failed: 'Ошибка платежа'
            }
          }
        },
        offer: {
          amount: {
            title: 'Сумма займа',
            placeholderStart: 'от',
            placeholderEnd: 'до'
          },
          term: {
            title: 'Срок',
            placeholderStart: 'от',
            placeholderEnd: 'до',
            days: 'дней'
          },
          percent: {
            title: '% годовых',
            placeholderStart: 'от',
            placeholderEnd: 'до',
          },
          income: {
            title: 'Доход*'
          },
          rating: {
            title: 'Рейтинг',
            placeholder: 'от 0 до 100'
          },
          count: {
            title: 'Кол-во займов',
            placeholder: 'от 1 до 20',
            notice: 'Обратите внимание, что выбрав количество займов (публикаций) ваше предложение будет публиковаться исходя из заявленного вами числа раз. Соответственно такое количество займов может быть выдано вами (в т.ч. автоматически) на аналогичных условиях, если на него откликнутся Заёмщики.'
          },
          btn: 'Создать заявку',
          toastMsg: 'Заявка успешно создана',
          publish: 'Опубликовать',
          unpublish: 'Снять с публикации',
          delete: 'Удалить'
        },
        deleteOffer: {
          title: 'Вы действительно хотите удалить заявку?',
          text: 'Это действие не обратимо, список удаленных заявок вы сможете просмотреть в архиве.',
          confirmBtn: 'Подтвердить',
          cancelBtn: 'Отмена'
        },
        activeOffers: {
          title: 'Мои заявки',
          noData: 'нет данных',
          moreOffers: 'Развернуть ещё',
          items: {
            amount: 'Сумма',
            term: 'Срок',
            percent: '% годовых',
            income: 'Итого к возврату*',
            rating: 'Рейтинг',
            count: 'Кол-во займов',
            status: 'Статус'
          },
          published: {
            yes: 'Да',
            no: 'Нет',
            published: 'Опубликована',
            "not_published": 'Не опубликована',
            blocked: 'Заблокирована',
            failed: 'Отменена',
            draft: 'Не опубликована',
            archive: 'Удалена',
            processed: 'Обработана',
            successful_closed: 'Обработана',
            temporarily_blocked: 'Временно заблокировано'
          },
          publishBtn: {
            published: 'Снять с публикации',
            "not_published": 'Опубликовать'
          }
        },
        expiredLoan: {
          link: 'Создать Претензию',
          text: 'Оформление искового заявления в третейский суд'
        },
        expiredModal: {
          title: 'Вы воспользовались функцией “Создание Претензии”.',
          advicesBtn: 'Практические советы',
          claimBtn: 'Создать Претензию',
          claimAdvices: {
            title: 'Практические советы:',
            first: 'При невозврате денежных средств в установленный срок у Займодавца возникает право на обращение в суд. Следует учитывать, что в соответствии с условиями договора займа и третейской оговоркой предусмотрен обязательный претензионный порядок и определён суд для рассмотрения споров — постоянно действующий третейский суд ООО «Центр прикладной психологии и детекции лжи КРИСТАЛЛ».',
            secondStart: 'Воспользовавшись инструментами Сервиса, можно сформировать Претензию, которая будет направлена Заёмщику (должнику). ',
            secondBold: 'Обращаем внимание, что максимальный размер начисляемой пени составляет 50% от суммы основного долга. Рекомендуем дождаться предусмотренного начисления и затем сформировать Претензию.',
            secondEnd: ' Если не дожидаться начисления максимального размера пени, предусмотренного договором займа, то и подать иск можно на тот размер требований, которые были определены Претензией на дату её составления. В течение 10 дней с момента направления претензии Заёмщиком (должником) должен быть дан ответ Займодавцу на претензию и/или погашены требования.',
            third: 'При отсутствии ответа на Претензию и/или отсутствии погашения долга по истечении указанного срока Займодавец имеет право обратиться в суд, воспользовавшись инструментами Сервиса по составлению и отправке Искового заявления в третейский суд ООО «Центр прикладной психологии и детекции лжи КРИСТАЛЛ».',
            fourth: 'В момент подачи Искового заявления должен быть оплачен по реквизитам третейского суда в соответствии с тарифами третейского суда третейский сбор за рассмотрение искового заявления (2 базовые величины) и прикреплён скрин (фото) чека оплаты третейского сбора.'
          }
        },
        noCardLink: 'Добавьте',
        noCardText: ' карту, на которую вы хотите получить деньги',
        noScoringAgreement: {
          start: 'Для выставления рейтинга (скоринговой оценки) необходимо ',
          link: 'дать согласие',
          end: ' на предоставление кредитного отчёта из Кредитного регистра'
        }
      }
    },
    footer: {
      tagline: 'Ваш надежный партнер в мире онлайн-займов',
      serviceTitle: 'Сервис потребительского онлайн-заимствования',
      links: {
        about: 'О нас',
        contacts: 'Контакты',
        news: 'Новости',
        personalDataPolicy: 'Политика обработки персональных данных',
        docs: 'Документы',
        legal: 'Законодательство',
        justice: 'Третейский суд',
        questions: 'Частые вопросы'
      },
      social: 'Мы в соц. сети:',
      license: {
        title: 'Свидетельство №1',
        text: 'Национального банка Республики Беларусь о включении в реестр операторов сервисов онлайн-заимствования (Указ Президента Республики Беларусь от 25 мая 2021 г. № 196)'
      },
      legal: {
        cookies: 'Мы используем сооkies для сбора обезличенных персональных данных. Оставаясь на сайте, Вы соглашаетесь на сбор таких данных. Предоставление займов сопряжено с определенным риском.',
        company: 'ООО «ИФС» (С) Свидетельство № 1 Национального банка Республики Беларусь от 14.01.2022'
      }
    },
    cookieBanner: {
      title: 'Мы используем файлы cookie',
      text: 'Мы используем файлы cookie для корректной работы сайта, сохранения ваших настроек, а также сбора аналитики или показа рекламы. Нажимая «Принять все», вы даете согласие на обработку данных в соответствии с нашей Политикой в отношении обработки файлов cookie. Вы можете настроить параметры cookie или отклонить необязательные файлы.',
      policy: 'С политикой обработки персональных данных вы можете ознакомиться ',
      policyLink: 'здесь',
      decline: 'Отклонить',
      accept: 'Принять все',
      settings: 'Настроить cookie',
      options: {
        technical: 'Технические (обязательные) cookie. Необходимы для базового функционирования сайта (авторизация, сохранение товаров в корзине, сессии безопасности). Без них сайт не сможет работать. Не требуют согласия.',
        analytics: 'Аналитические cookie. Помогают нам понять, как посетители взаимодействуют с сайтом, собирая обезличенную статистику.',
        advertising: 'Функциональные и рекламные cookie. Позволяют запоминать ваш выбор (язык, регион), а также используются рекламными системами для показа объявлений, соответствующих вашим интересам.'
      }
    },
    header: {
      signOutBtn: 'Выйти',
      signInBtn: 'Войти',
      getLoan: 'Получить займ',
      returnLoan: 'Вернуть займ',
      investing: 'Инвестировать',
      about: 'О нас',
      register: 'Зарегистрироваться',
      personal: 'СЕРВИС ПОТРЕБИТЕЛЬСКОГО ОНЛАЙН-ЗАИМСТВОВАНИЯ',
      business: 'СЕРВИС БИЗНЕС-ОНЛАЙН-ЗАИМСТВОВАНИЯ'
    },
    mainPage: {
      operator: {
        title: 'Об операторе сервиса потребительского-онлайн-заимствования',
        first: 'ООО «ИФС» (Оператор сервиса потребительского онлайн-заимствования) оказывает платные услуги по созданию условий для заключения и исполнения посредством сервиса потребительского онлайн-заимствования договоров займа денежных средств и договоров, заключенных в обеспечение исполнения обязательств по договору займа денежных средств в соответствии с утвержденными Правилами сервиса потребительского онлайн-заимствования «Капуста — онлайн-заимствования», условиями договора возмездного оказания услуг и тарифной политикой сервиса.',
        second: 'Оператор сервиса потребительского онлайн-заимствования не является стороной по заключаемым посредством этого сервиса договору займа денежных средств и договору, заключенному в обеспечение исполнения обязательств по договору займа денежных средств.',
        third: 'Оператор сервиса потребительского онлайн-заимствования также не вправе привлекать на свои банковские счета и аккумулировать денежные средства клиентов для их последующего направления заемщикам, иным образом участвовать в движении денежных средств при осуществлении расчетов по договорам займа денежных средств.'
      },
      diploma: {
        title: 'Международная бизнес-премия «Номер Один»',
        desc: 'kapusta.by — победитель в номинации «Оператор сервиса онлайн-заимствования»',
        alt: 'Диплом X ежегодной международной бизнес-премии «Номер Один» 2026'
      },
      heading: {
        title: 'Капуста — сервис потребительского онлайн-заимствования',
        desc: {
          link: 'см.Правила сервиса потребительского онлайн-заимствования',
          textStart: 'Автоматизированный сервис потребительского онлайн-заимствования, позволяющий физическим лицам дистанционно осуществлять заключение договоров займа денежных средств. Участниками данного сервиса в соответствии с Правилами работы данного сервиса могут быть только физические лица (подробнее — ',
          textEnd: '). Сервис потребительского онлайн-заимствования начал свою работу в мае 2023 года и доступен для заёмщиков и займодавцев по всей Беларуси.',
          text: 'Первый и крупнейший в Беларуси высокотехнологичный автоматизированный сервис онлайн-заимствования, разработанный резидентом Парка высоких технологий – ООО «ИФС».\nВ основе работы сервиса «Капуста» собственные IT-разработки:\nОнлайн-регистрация и биометрическая идентификация клиентов через Межбанковскую систему идентификации.\nУникальная система оценки платежеспособности заемщиков по десяткам параметров с использованием интеграций с Кредитным регистром и другими государственными системами.\nАвтоматическая генерация договоров займа и удаленное подписание их через АСП (аналог собственноручной подписи).\nБыстрые онлайн переводы через сервис BePaid.\nУникальный процессинговый модуль, обеспечивает полную автоматизацию учета займов, в реальном времени выполняя математически точный расчет процентов, пеней и задолженностей, мгновенно отражая движения денежных средств в системе.\nЕдинственная на рынке технология автоматической генерации исковых заявлений с мгновенным направлением в Третейский суд.',
          textNotice: '(Указ Президента Республики Беларусь от 25 мая 2021 г. № 196)'
        },
        btn: 'ЗАРЕГИСТРИРОВАТЬСЯ'
      },
      offers: {
        notice: '* Cделки по предоставлению денежных средств в займы посредством сервиса потребительского онлайн-заимствования <br/> и заключение договоров в обеспечение исполнения обязательств по договору займа денежных средств носят рисковый характер',
        title: 'Они готовы выдать деньги прямо сейчас!',
        btn: 'Получить деньги',
        filters: {
          from: 'от',
          to: 'до',
          days: 'дней',
          amount: {
            title: 'Сумма займа'
          },
          terms: {
            title: 'Срок займа',
          },
          rating: {
            title: 'Рейтинг',
          },
          applyBtn: 'Применить',
          resetBtn: 'Очистить',
          showAvailable: 'Показать займы доступные мне'
        },
        tableTitle: {
          amount: 'Сумма',
          return: 'К возвр.',
          returnMobile: 'К возврату',
          issuedBy: 'Срок',
          rating: 'Рейтинг'
        },
        more: 'Раскрыть ещё'
      },
      hiw: {
        title: 'Как работает Капуста:',
        first: {
          title: 'Регистрация',
          desc: 'немного терпения и вы становитесь полноценным участником Сервиса и одновременно владельцем личного «карманного» Банка. Регистрация через МСИ (в т.ч. с использованием биометрии)'
        },
        second: {
          title: 'Получение займа',
          desc: 'все сделки займов заключаются напрямую между физическими лицами. Для получения денег воспользуйтесь предложениями от Займодавцев и сделайте свой выбор или создайте свою заявку на займ'
        },
        third: {
          title: 'Выдача займа',
          desc: 'на нашем сайте вы можете создать свои уникальные предложения по займам. Займодавцы не ограничены в количестве совершаемых сделок на нашем Сервисе'
        }
      },
      advantages: {
        title: 'Почему все выбирают Капусту:',
        items: {
          first: 'БЕЗ: справок, залогов, страховок и поручителей',
          second: '95% вероятность одобрения. Деньги на карту за 15 минут',
          third: 'Выдача и погашение займа круглосуточно',
          preFourth: 'Аттестованная система защиты информации по классу 3-ин, 3-юл',
          fourth: 'SSL сертификат, защита личной информации',
          fifth: 'Справочно-информационная поддержка',
          sixth: 'Взыскание в третейском суде'
        }
      },
      targetLoans: {
        title: 'Присмотритесь к целевым займам, разработанным специально для вас!',
        amount: 'Сумма:',
        time: 'Срок:',
        return: 'К возврату:',
        days: 'дней',
        btn: 'Получить деньги',
        first: 'Простой',
        second: 'До зарплаты',
        third: 'Универсальный',
        fourth: 'Крупная сделка',
        fifth: 'На ремонт',
        sixth: 'На отдых'
      },
      newLoan: {
        title: 'Не нашли подходящего предложения?',
        descFirstRow: 'Хотите получить займ на своих условиях?',
        descSecondRow: 'Создайте свою Уникальную заявку!'
      },
      partners: {
        title: 'Наши партнёры'
      }
    },
    notFound: {
      title: 'Упс!',
      notice: 'Возможно, запрашиваемая страница временно не доступна :(',
      btn: 'Вернуться на главную'
    },
    passwordRecovery: {
      backBtn: 'Вернуться',
      firstStep: {
        title: 'Для того, чтобы восстановить доступ к личному кабинету, укажите свой номер телефона',
        login: {
          label: 'Введите номер телефона',
          btn: 'Далее'
        }
      },
      secondStep: {
        title: 'Введите код из СМС',
        otp: {
          label: 'Введите код',
          btn: 'Далее'
        }
      },
      idNumberCheckStep: {
        title: 'Введите персональный личный номер',
        idNumber: {
          placeholder: '1111111A111AA1',
          btn: 'Далее'
        }
      },
      thirdStep: {
        title: 'Создание нового пароля',
        password: {
          label: 'Новый пароль'
        },
        repeatPassword: {
          label: 'Новый пароль ещё раз'
        },
        saveBtn: 'Сохранить',
        cancelBtn: 'Отмена'
      }
    },
    docksUploader: {
      errorMsg: 'Необходимо загрузить файлы',
      validationErrorMsg: 'Не верный формат файла',
      downloadBtn: 'Прикрепить файл'
    },
    hello: 'works',
    errorModal: {
      title: 'Ошибка',
      btn: 'OK'
    },
    signUp: {
      requiredFields: {
        title: 'Обязательные поля',
        carPassport: 'Технический паспорт автомобиля (минимум 2 файла)',
        realEstate: 'Свидетельство о регистрации недвижимости',
      },
      signUpBtn: 'Зарегистрироваться',
      isDataFullAndCorrect: {
        text: 'Я подтверждаю полноту и корректность предоставленных мной данных'
      },
      isAgreeWithServiceRules: {
        text: 'Я ознакомлен(а) и согласен(а) с ',
        link: 'Правилами работы Сервиса ',
        secondText: 'и ',
        secondLink: 'Политикой в отношении обработки персональных данных'
      },
      isAgreeWithPersonalDataActions: {
        textFirst: 'Я даю ',
        link: 'согласие',
        textSecond: ' на обработку своих персональных данных'
      },
      isAgreeWithServiceAgreement: {
        textFirst: 'Я ознакомлен и согласен с условиями ',
        link: 'Договора возмездного оказания услуг',
        textSecond: ' и принимаю условия данной оферты'
      },
      isAgreeToGetBankReport: {
        textFirst: 'Даю своё ',
        link: 'согласие на получение отчёта',
        textSecond: ' из Кредитного регистра НБРБ'
      },
      title: 'Анкета',
      description: 'Будьте внимательны на данном этапе. * - обязательны для заполнения',
      basicBlock: {
        title: 'Контактные данные',
        keyWord: {
          title: 'Кодовое слово',
          noticeMsg: 'Может использоваться для подтверждения операций',
          warningMsg: 'Кодовое слово служит для идентификации вас как пользователя. Поменять его в дальнейшем нельзя. Обязательно запомните кодовое слово.'
        },
        msisdn: {
          title: 'Номер телефона'
        },
        otp: {
          title: 'Код из SMS',
          sendOtp: 'Получить код'
        },
        email: {
          title: 'Email'
        },
        fullName: {
          title: 'Полное наименование*'
        },
        shortName: {
          title: 'Краткое наименование*'
        },
        unp: {
          title: 'УНП*'
        },
        formerName: {
          title: 'Регистрирующий орган*'
        },
        regNumber: {
          title: 'Регистрационный номер*'
        },
        regDate: {
          title: 'Дата регистрации*',
          placeholder: 'ДД/ММ/ГГГГ'
        },
        otpToastMsg: 'Код выслан'
      },
      role: {
        title: 'Выберите статус'
      },
      mainData: {
        title: 'Основные сведения',
        surname: {
          title: 'Фамилия*'
        },
        name: {
          title: 'Имя*'
        },
        middleName: {
          title: 'Отчество',
          noMiddleName: 'Нет отчества'
        },
        birthDate: {
          title: 'Дата рождения',
          placeholder: 'ДД.ММ.ГГГГ'
        },
        citizenship: {
          title: 'Гражданство'
        },
        gender: {
          title: 'Пол',
          male: 'Мужской',
          female: 'Женский'
        },
        birthPlace: {
          title: 'Место рождения',
          placeholder: 'В точном соответствии с паспортными данными'
        }
      },
      passwordBlock: {
        title: 'Логин и пароль',
        login: {
          title: 'Логин*'
        },
        password: {
          title: 'Пароль*'
        }
      },
      addressBlock: {
        title: 'Адрес',
        registrationAdress: {
          title: 'Адрес регистрации (прописка)*',
          theSame: 'Адрес проживания совпадает с адресом регистрации'
        },
        livingAddress: {
          title: 'Адрес проживания',
          placeholders: {
            country: 'Республика Беларусь',
            region: 'Минская',
            district: 'Минский',
            locality_type: 'Город',
            locality: 'Минск',
            street_type: 'Улица',
            street: 'Минская',
            house: '1',
            building: '1',
            apartment: '1',
            postal_code: '220000',
          },
        },
        fields: {
          country: 'Страна',
          region: 'Область',
          district: 'Район',
          locality_type: 'Тип населенного пункта',
          locality: 'Название населенного пункта',
          street_type: 'Тип локации',
          street: 'Название локации',
          house: 'Номер дома',
          building: 'Корпус',
          apartment: 'Квартира',
          postal_code: 'Почтовый индекс',
        },
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      postalAddressBlock: {
        title: 'Почтовый адрес',
        addressTheSame: 'Почтовый адрес совпадает с адресом места нахождения',
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      idBlock: {
        title: 'Данные, удостоверяющие личность',
        idType: {
          title: 'Вид документа*',
          idTypeList: {
            3: 'Паспорт Республики Беларусь',
            6: 'Вид на жительство Республики Беларусь',
            15: 'Идентификационная карта гражданина Республики Беларусь',
            16: 'Биометрический вид на жительство в Республике Беларусь иностранного гражданина',
            17: 'Биометрический вид на жительство в Республике Беларусь лица без гражданства',
          }
        },
        idNumber: {
          title: 'Номер документа*'
        },
        idIdentification: {
          title: 'Идентификационный номер (ID)*'
        },
        mainDocument: {
          title: 'Основной документ*',
          placeholder: '',
          list: {
            3: 'Паспорт Республики Беларусь',
            6: 'Вид на жительство Республики Беларусь',
            15: 'Идентификационная карта гражданина Республики Беларусь',
            16: 'Биометрический вид на жительство в Республике Беларусь иностранного гражданина',
            17: 'Биометрический вид на жительство в Республике Беларусь лица без гражданства',
          },
        },
        seriesAndNumber: {
          title: 'Серия и номер*',
          placeholder: 'AA1234567'
        },
        idDateIssue: {
          title: 'Дата выдачи*',
          placeholder: 'ДД.ММ.ГГГГ'
        },
        expireDate: {
          title: 'Срок действия документа*',
          placeholder: 'ДД.ММ.ГГГГ'
        },
        idIssuedBy: {
          title: 'Кем выдан*',
          placeholder: 'В точном соответствии с паспортными данными'
        }
      },
      livingAddressBlock: {
        title: 'Адрес места жительства',
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      destinationAddressBlock: {
        title: 'Адрес места пребывания',
        addressTheSame: 'Место пребывания совпадает с местом жительства (регистрации)',
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      authorizedPersonBlock: {
        title: 'Данные уполномоченного лица',
        citizen: 'Резидент Республики Беларусь',
        notCitizen: 'Нерезидент Республики Беларусь',
        phone: {
          title: 'Номер телефона*',
          placeholder: '+ 375 (29) 111-11-11'
        },
        basedOn: {
          title: 'На основании чего действует руководитель*'
        },
        surname: {
          title: 'Фамилия*'
        },
        name: {
          title: 'Имя*'
        },
        middleName: {
          title: 'Отчество',
          noMiddleName: 'Нет отчества'
        },
        citizenship: {
          title: 'Гражданство*',
          countryList
        },
        birthplace: {
          title: 'Место рождения*',
          placeholder: 'В точном соответствии с паспортными данными'
        },
        post: {
          title: 'Должность*'
        },
        website: {
          title: 'Адрес сайта в Интернете'
        },
        email: {
          title: 'Адрес электронной почты'
        }
      },
      jobBlock: {
        title: 'Сведения о работе',
        typeOfEmployment: {
          title: 'Вид занятости*',
          list: {
            1: 'Работаю официально',
            2: 'Работаю неофициально',
            3: 'Временно не работаю',
            4: 'В декретном отпуске',
            5: 'Индивидуальный предприниматель',
            6: 'Иной источник дохода',
            7: 'Пенсионер',
            8: 'Работающий пенсионер',
            9: 'Самозанятый',
            10: 'Студент',
            11: 'Договор подряда'
          }
        },
        fieldOfEmployment: {
          title: 'Сфера занятости*',
          list: {
            1: 'Банковское дело / финансы',
            2: 'Вооружённые силы / правоохр. органы',
            3: 'Государственное управление',
            4: 'Здравоохранение / фармация',
            5: 'IT',
            6: 'Коммунальное хозяйство',
            7: 'Культура',
            8: 'Наука и образование',
            9: 'Промышленность',
            10: 'Развлечения',
            11: 'Сельское хозяйство',
            12: 'Строительсво',
            13: 'Торговля',
            14: 'Услуги',
            15: 'Работник ИП',
            16: '-'
          }
        },
        nameOfOrganization: {
          title: 'Наименование организации*',
          placeholder: 'Полное юридическое название организации'
        },
        post: {
          title: 'Должность*',
          list: {
            1: 'Специалист',
            2: 'Рабочий',
            3: 'Руководитель среднего звена',
            4: 'Главный бухгалтер',
            5: 'Главный инженер',
            6: 'Заместитель руководителя',
            7: 'Руководитель',
            8: 'Другое',
            9: '-'
          }
        },
        otherPositionType: {
          title: 'Введите должность*'
        },
        workExperience: {
          title: 'Стаж работы в данной организации*',
          placeholder: 'Кол-во месяцев'
        }
      },
      entityDocsBlock: {
        title: 'Документы юридического лица',
        description: 'Формат загружаемого файла: jpeg, jpg, png, pdf. Максимальный размер 1-го загружаемого файла 5 МБ',
        order: {
          title: '1. Документ, удостоверяющий право уполномоченного лица (приказ, распоряжение)',
          error: 'Необходимо загрузить файлы'
        },
        register: {
          title: '2. Свидетельство о регистрации'
        },
        charter: {
          title: '3. Устав'
        },
        extra: {
          title: '4. Дополнительные файлы'
        }
      },
      roleBlock: {
        borrower: {
          title: 'Заёмщик',
          subtitle: '(получить займ)'
        },
        lender: {
          title: 'Займодавец',
          subtitle: '(выдать займ)'
        }
      },
      extraBlock: {
        title: 'Дополнительные сведения',
        education: {
          title: 'Образование',
          list: {
            1: 'Незаконченное среднее',
            2: 'Среднее',
            3: 'Средне-специальное',
            4: 'Незаконченное высшее',
            5: 'Высшее'
          }
        },
        driversLicense: {
          title: 'Водительское удостоверение',
          yes: 'Имею',
          no: 'Не имею'
        },
        car: {
          title: 'Автомобиль в собственности',
          yes: 'Имею',
          no: 'Не имею',
          technicalPassport: {
            title: 'Технический паспорт автомобиля',
            hint: 'Максимум 4 файла: обязательно прикрепите 2 файла с изображением техпаспорта с лицевой и оборотной стороны',
            attachBtn: 'Прикрепить'
          }
        },
        realEstate: {
          title: 'Недвижимость в собственности',
          yes: 'Имею',
          no: 'Не имею',
          registrationCertificate: {
            title: 'Свидетельство о регистрации недвижимого имущества',
            hint: 'Максимум 5 файлов: обязательно прикрепите 1 файл',
            attachBtn: 'Прикрепить'
          }
        },
        familyStatus: {
          title: 'Семейное положение',
          list: {
            1: 'Холост / Не замужем',
            2: 'Женат / Замужем'
          }
        },
        dependensNumber: {
          title: 'Количество иждивенцев*'
        },
        childExpenses: {
          title: 'Обязанность возмещать расходы, затраченные государством на содержание детей (в детских домах, интернатах, спец.учреждениях и пр.)',
          yes: 'Имею',
          no: 'Не имею'
        },
        totalIncome: {
          title: 'Общий ежемесячный доход в BYN*'
        }
      }
    },
    signIn: {
      title: 'Добро пожаловать в Капусту!',
      loginPlaceholder: 'Номер телефона',
      passwordPlaceholder: 'Пароль',
      otpPlaceholder: 'Код из SMS',
      sendCode: 'ОТПРАВИТЬ КОД',
      signInBtn: 'Войти',
      msi: 'Зарегистрироваться',
      forgotPassword: 'Забыли пароль?',
      otpToastMsg: 'Код выслан'
    },
    authPasswordChange: {
      title: 'В целях безопасности для продолжения работы в сервисе необходимо сменить пароль',
      loginPlaceholder: 'Номер телефона',
      passwordPlaceholder: 'Пароль',
      confirmPasswordPlaceholder: 'Подтверждение пароля',
      otpPlaceholder: 'Код из SMS',
      sendCode: 'ОТПРАВИТЬ КОД',
      changePasswordBtn: 'Изменить пароль',
      otpToastMsg: 'Код выслан',
      successToastMsg: 'Пароль успешно изменён'
    },
    cardsPage: {
      addCardError: 'Не удалось добавить карту',
      addCardSuccess: 'Карта успешно добавлена',
      amountNotice: 'При добавлении карты минимальный остаток должен составлять 4 BYN ( Белорусский рубль )',
      mainCardTitle: 'Основная карта',
      secondaryCardTitle: 'Прочие карты',
      addCardBtn: 'Добавить карту',
      addEnotherBtn: 'ДОБАВИТЬ ДРУГУЮ КАРТУ',
      addNewBtn: 'ДОБАВИТЬ КАРТУ',
      empty: 'Список карт пуст',
      notVerified: 'Карта не верифицирована',
      card: {
        card: 'Номер карты',
        expiry: 'Срок действия',
        MIR: 'Мир/ Мгновенное зачисление возможно',
        VISA: 'Visa/ Мгновенное зачисление возможно',
        BELKART: 'BELKART/ Мгновенное зачисление возможно',
        MASTERCARD: 'Mastercard/ Мгновенное зачисление возможно',
        delete: 'Удалить карту'
      },
      deleteCard: {
        title: 'Внимание!',
        text: 'Вы действительно хотите удалить карту?',
        desc: 'При подтверждении удаления, информация о карте будет безвозвратно удалена. Вы уверены, что хотите удалить карту?',
        acceptBtn: 'Подтвердить',
        closeBtn: 'Отмена'
      },
      changeDefaultCard: {
        title: 'Смена основной карты',
        textStart: 'Вы уверены, что хотите выбрать банковскую карту с номером',
        textEnd: 'в качестве основной карты ?',
        confirmBtn: 'Подтвердить'
      }
    },
    msi: {
      regBtn: 'Продолжить',
      cancelBtn: 'Отмена',
      note: 'Регистрация на нашем сервисе реализована через Межбанковскую Систему Идентификации (МСИ)'
    },
    pagination: {
      range: '{from}-{to} из {total}'
    },
    sideMenu: {
      profile: 'Профиль',
      main: 'Главная',
      cards: 'Мои карты',
      settings: 'Настройки',
      archive: 'Архив',
      notifications: 'Уведомления',
      messages: 'Отправка сообщения администратору',
      "change-password": 'Смена пароля',
      "change-contact-info": 'Редактирование контактной информации',
      "change-work-info": 'Редактирование информации о месте работы',
      "edit-work-info-borrower": 'Редактирование информации о месте работы',
      "edit-work-info-lender": 'Редактирование информации о месте работы',
      "change-personal-data-agreement": 'Согласие на обработку персональных данных',
      "actual-info": 'Актуализация данных через МСИ',
      "sign-personal-data-agreement": 'Подписать согласие на обработку персональных данных',
      "sign-claim": 'Подписать претензию',
      "lawsuit-sign": 'Подписать исковое заявление в Третейский Суд',
      "sign-early-repayment": 'Уведомление о досрочном погашении',
      loan: 'Займ',
      documents: 'Документы'
    }
  }
}

export default ru;